/*
 * Copyright (c) 2023 Your Company Name
 * All rights reserved.
 */
/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
/*eslint-disable*/
import React, { useEffect, useState } from "react";

// react component plugin for creating a beautiful datetime dropdown picker
import Datetime from "react-datetime";
import moment from "moment";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import InputAdornment from "@material-ui/core/InputAdornment";

// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Contacts from "@material-ui/icons/Contacts";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
import Today from "@material-ui/icons/Today";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { addDeviceAction, upadateDeviceAction } from "action/deviceAction";

// style for this view
import stylesExtended from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import { useHistory } from "react-router";
import { connect } from "react-redux";

import * as service from "../../services/deviceService";
import * as serviceSim from "../../services/simCardService";
import * as notif from "components/Notification/notification";
import { useMemo } from "react";
import { useParams } from "react-router-dom-v5-compat";

const useStyles = makeStyles(styles);
const useStylesExtended = makeStyles(stylesExtended);

const DeviceUpdate = (props) => {
  //const history = useNavigate();
  const [listSimState, setListSimState] = useState();
  const [simSelectElem, setSimSelectElem] = useState();
  const [simSelectFinal, setSimSelectFinal] = useState("");
  const [simSelectSuplementaire, setSimSelectSuplementaire] = useState("");

  //const [simSelectFinalFromDB, setSimSelectFinalFromDB] = useState("")

  const [paramId, setParamId] = useState("");

  const [openNotif, setOpenNotif] = useState(false);

  // type validation
  const [modeleDevice, setModeleDevice] = React.useState("");
  const [modeleDeviceState, setModeleDeviceState] = React.useState("");

  const [numeroID, setNumeroID] = React.useState("");
  const [numeroIDState, setNumeroIDState] = React.useState("");

  const [dateRecepDevice, setDateRecepDevice] = React.useState("");
  const [dateRecepDeviceState, setDateRecepDeviceState] = React.useState("");

  const [expireDateDevice, setExpireDateDevice] = React.useState("");
  const [expireDateDeviceState, setExpireDateDeviceState] = React.useState("");

  const [activeDeviceSelect, setActiveDeviceSelect] = React.useState(true);

  const paramURLID = useParams().id;

  useEffect(() => {
    setParamId(paramURLID);
  }, []);

  const handleActiveDevice = (event) => {
    setActiveDeviceSelect(event.target.value);
    //  console.log('setActiveDeviceSelect', activeDeviceSelect)
  };

  const handleSim = (event) => {
    setSimSelectFinal(event.target.value);
  };

  useEffect(() => {
    //console.log('simSelectFinal', simSelectFinal)
  }, [simSelectFinal]);

  useEffect(() => {
    if (openNotif === true) {
      if (props.loadDeviceFromSaga.loading === false) {
        let msg;
        let title;

        if (props.loadDeviceFromSaga.error.length > 0) {
          if (paramId) {
            title = "Echeque Mise a jour Device";
            msg = "Mise a jours Device echoué";
          } else {
            title = "Echeque ajout Device";
            msg = "La Device " + numeroID + " n a pas ete ajouter";
          }
          notif.showFailedNotification(title, msg);
        } else {
          if (paramId) {
            title = "Mise a jour Device";
            msg = "La Device " + numeroID + "  a ete mise a jours";
          } else {
            title = "Ajout  Device";
            msg = "La Device " + numeroID + " a ete ajouter";
          }
          notif.showSuccessNotification(title, msg);
        }
        setOpenNotif(false);
      }
    }
  }, [props.loadDeviceFromSaga]);

  useEffect(() => {
    if (paramId) {
      const data = {
        numeroDevice: paramId,
      };

      /*
        dateReception: "2020-12-01"
dureeValidite: "2020-12-08"
enMarche: true
identifiantDevice: 1
isActive: "true"
latitude: "14.74328"
longitude: "-17.511356666666668"
modeleDevice: "HQ"
numeroDevice: "7801059466"
        */

      service
        .getItemDevice(data)
        .then((res) => {
          // console.log("res getItemDevice = ", res)

          if (res.sim !== undefined) {
            setSimSelectSuplementaire(
              <MenuItem
                classes={{
                  root: classesExtended.selectMenuItem,
                  selected: classesExtended.selectMenuItemSelected,
                }}
                // selected={(deviceSelectFinal === device.identifiantDevice) ? true : false }
                value={res.sim.numeroDeSerieSim}
              >
                {res.sim.numeroCarteSim}
              </MenuItem>
            );
            //console.log('res.sim.numeroCarteSim', res.sim.numeroDeSerieSim)
            setSimSelectFinal(res.sim.numeroDeSerieSim);
          }

          setNumeroID(res.numeroDevice);
          if (verifyLength(res.numeroDevice, 0)) {
            setNumeroIDState("success");
          }
          setModeleDevice(res.modeleDevice);
          if (verifyLength(res.modeleDevice, 0)) {
            setModeleDeviceState("success");
          }
          setDateRecepDevice(res.dateReception);
          if (verifyLength(res.dateReception, 0)) {
            setDateRecepDeviceState("success");
          }
          setExpireDateDevice(res.dureeValidite);
          if (verifyLength(res.dureeValidite, 0)) {
            setExpireDateDeviceState("success");
          }

          setActiveDeviceSelect(res.isActive);

          // console.log('RES = ***** = ', res)
          /* 
            
            
            
            
            //setactivation(res.type)
            setactivationState("success");
*/
        })
        .catch((error) => {
          //console.log('error = ',error)
        });
    }
  }, [paramId]);

  const successDelete = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Deleted!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Your imaginary file has been deleted.
      </SweetAlert>
    );
  };
  const cancelDetele = () => {
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Cancelled"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Your imaginary file is safe :)
      </SweetAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };

  // function that returns true if value is dateRecep, false otherwise
  const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  // function that verifies if a string has a given length or not
  const verifyLength = (value, length) => {
    if (value.length > length) {
      return true;
    }
    return false;
  };
  // function that verifies if value contains only numbers
  const verifyNumber = (value) => {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  };

  const typeClick = () => {
    let error = false;

    if (modeleDevice === "") {
      setModeleDeviceState("error");
      error = true;
    }

    if (numeroID === "") {
      error = true;
      setNumeroIDState("error");
    }

    if (dateRecepDevice === "") {
      error = true;
      setDateRecepDeviceState("error");
    }

    if (expireDateDevice === "") {
      error = true;
      setExpireDateDeviceState("error");
    }

    if (activeDeviceSelect === "") {
      error = true;
    }
    /*
{
  dateReception: "2020-12-01"
dureeValidite: "2020-12-08"
enMarche: true
identifiantDevice: 1
isActive: "true"
latitude: "14.74328"
longitude: "-17.511356666666668"
modeleDevice: "HQ"
numeroDevice: "7801059466"
*/

    let data = {
      modeleDevice: modeleDevice,
      dateReception: dateRecepDevice,
      isActive: activeDeviceSelect === true ? 1 : 0,
      dureeValidite: expireDateDevice,
      numeroDevice: numeroID,
      identifiantDevice: paramId,
      latitude: "0.0",
      longitude: "0.0",
      dateMajPosition: "2021-01-01",
      enMarche: 0,
      etatDevices: 1,
    };
    if (simSelectFinal) {
      data = {
        ...data,
        sim: {
          numeroDeSerieSim: simSelectFinal,
        },
      };
    }

    if (error === false) {
      setOpenNotif(true);
      //console.log("*****DATA******", data)
      if (paramId) {
        props.deviceUpdateDispatch(data);
      } else {
        props.deviceAddDispatch(data);
      }

      //history('/')
    }
  };

  const classes = useStyles();
  const classesExtended = useStylesExtended();

  const selectSim = async () => {
    const listSim = await serviceSim.getListUnusedCarteSim();
    setListSimState(listSim);
  };

  useEffect(() => {
    selectSim();
  }, []);

  useEffect(() => {
    if (listSimState !== undefined) {
      const sims = listSimState.map((sim) => {
        return (
          <MenuItem
            key={sim.numeroDeSerieSim}
            classes={{
              root: classesExtended.selectMenuItem,
              selected: classesExtended.selectMenuItemSelected,
            }}
            selected={simSelectFinal === sim.numeroDeSerieSim ? true : false}
            value={sim.numeroDeSerieSim}
          >
            {sim.numeroCarteSim}
          </MenuItem>
        );
      });

      const simElem = () => {
        return (
          <Select
            MenuProps={{
              className: classesExtended.selectMenu,
            }}
            classes={{
              select: classesExtended.select,
            }}
            value={simSelectFinal}
            onChange={handleSim}
            inputProps={{
              name: "simItem",
              id: "simItem",
            }}
          >
            <MenuItem
              disabled
              classes={{
                root: classesExtended.selectMenuItem,
              }}
            >
              Selection Carte Sim
            </MenuItem>

            <MenuItem
              classes={{
                root: classesExtended.selectMenuItem,
              }}
              value={""}
              selected={simSelectFinal === "" ? true : false}
            >
              Aucune SIM
            </MenuItem>

            {sims}
            {simSelectSuplementaire}
          </Select>
        );
      };

      setSimSelectElem(simElem);
    }
  }, [listSimState, simSelectFinal]);

  /*
        
etatDevice: "1"
telephone1: "555555"
telephone2: "555555"
type: "333333"
        */

  const handleDateExp = (data) => {
    const date = moment(data).format("YYYY-MM-DD");
    setExpireDateDevice(date);
    if (date.length === 10) {
      setExpireDateDeviceState("success");
    } else {
      setExpireDateDeviceState("error");
    }
  };

  const handleDateRecep = (data) => {
    const date = moment(data).format("YYYY-MM-DD");
    setDateRecepDevice(date);
    if (date.length === 10) {
      setDateRecepDeviceState("success");
    } else {
      setDateRecepDeviceState("error");
    }
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="info" text>
            <CardText color="info">
              <h4 className={classes.cardTitle}>Type Validation</h4>
            </CardText>
          </CardHeader>
          <CardBody>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    Modele
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <CustomInput
                    success={modeleDeviceState === "success"}
                    error={modeleDeviceState === "error"}
                    id="modeleDevice"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        if (verifyLength(event.target.value, 0)) {
                          setModeleDeviceState("success");
                        } else {
                          setModeleDeviceState("error");
                        }
                        setModeleDevice(event.target.value);
                      },
                      value: modeleDevice,

                      type: "text",
                      endAdornment:
                        modeleDeviceState === "error" ? (
                          <InputAdornment position="end">
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>Modele</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    Identifiant
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <CustomInput
                    success={numeroIDState === "success"}
                    error={numeroIDState === "error"}
                    id="numeroID"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        if (verifyLength(event.target.value, 0)) {
                          setNumeroIDState("success");
                        } else {
                          setNumeroIDState("error");
                        }
                        setNumeroID(event.target.value);
                      },
                      value: numeroID,
                      type: "text",
                      endAdornment:
                        numeroIDState === "error" ? (
                          <InputAdornment position="end">
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>Identifiant</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    Date de reception
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <br />
                  <br />

                  <FormControl fullWidth>
                    <Datetime
                      onChange={handleDateRecep}
                      dateFormat={"DD-MM-YYYY"}
                      timeFormat={false}
                      closeOnSelect={true}
                      inputProps={{ placeholder: "Date de reception" }}
                    />
                  </FormControl>
                </GridItem>

                {/* 
                      <GridItem xs={12} sm={2}>
                        <FormLabel className={classes.labelHorizontal}>
                          Date de reception
                        </FormLabel>
                      </GridItem>
                      <GridItem xs={12} sm={7}>
                        <CustomInput
                          success={dateRecepDeviceState === "success"}
                          error={dateRecepDeviceState === "error"}
                          id="dateRecepDevice"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event => {
                              if (verifyLength(event.target.value, 0)) {
                                setDateRecepDeviceState("success");
                              } else {
                                setDateRecepDeviceState("error");
                              }
                              setDateRecepDevice(event.target.value);
                            },
                            type: "text",
                            value: dateRecepDevice,
                            endAdornment:
                              dateRecepDeviceState === "error" ? (
                                <InputAdornment position="end">
                                  <Close className={classes.danger} />
                                </InputAdornment>
                              ) : (
                                undefined
                              )
                          }}
                        />
                      </GridItem>
                      */}
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>datereception</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    Date d expiration
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <br />
                  <br />

                  <FormControl fullWidth>
                    <Datetime
                      onChange={handleDateExp}
                      dateFormat={"DD-MM-YYYY"}
                      timeFormat={false}
                      closeOnSelect={true}
                      inputProps={{ placeholder: "Date Expiration" }}
                    />
                  </FormControl>
                </GridItem>

                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>date expiration</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    Etat
                  </FormLabel>
                </GridItem>

                <GridItem xs={12} sm={7}>
                  <FormControl
                    fullWidth
                    className={classesExtended.selectFormControl}
                  >
                    <InputLabel
                      htmlFor="Deviceple-select"
                      className={classesExtended.selectLabel}
                    ></InputLabel>
                    <Select
                      MenuProps={{
                        className: classesExtended.selectMenu,
                      }}
                      classes={{
                        select: classesExtended.select,
                      }}
                      value={activeDeviceSelect}
                      onChange={handleActiveDevice}
                      inputProps={{
                        name: "DevicepleSelect",
                        id: "Deviceple-select",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classesExtended.selectMenuItem,
                        }}
                      >
                        Activation
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classesExtended.selectMenuItem,
                          selected: classesExtended.selectMenuItemSelected,
                        }}
                        selected={activeDeviceSelect === false ? true : false}
                        value={false}
                      >
                        Desactiver
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classesExtended.selectMenuItem,
                          selected: classesExtended.selectMenuItemSelected,
                        }}
                        selected={activeDeviceSelect === true ? true : false}
                        value={true}
                      >
                        Active
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>Sim</FormLabel>
                </GridItem>

                <GridItem xs={12} sm={7}>
                  <FormControl
                    fullWidth
                    className={classesExtended.selectFormControl}
                  >
                    <InputLabel
                      htmlFor="Sim-select"
                      className={classesExtended.selectLabel}
                    ></InputLabel>
                    {simSelectElem}
                  </FormControl>
                </GridItem>
              </GridContainer>
            </form>
          </CardBody>
          <CardFooter className={classes.justifyContentCenter}>
            <Button color="info" onClick={typeClick}>
              Validate Inputs
            </Button>
          </CardFooter>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

const mapStateToProps = (state) => {
  //console.log('state Device', state.devices)
  return {
    loadDeviceFromSaga: state.devices,
  };
};

const mapsDispatchToProps = (dispatch) => {
  return {
    deviceAddDispatch: (data) => {
      dispatch(addDeviceAction(data));
    },
    deviceUpdateDispatch: (data) => {
      dispatch(upadateDeviceAction(data));
    },
  };
};

export default connect(mapStateToProps, mapsDispatchToProps)(DeviceUpdate);
